import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getDefectCategories = createAsyncThunk(
  '/getDefectCategories',
  async () => {
    const response = await axios.get('/GetDefectCategories');
    return response.data;
  }
);

export const getDefectCategoryTypes = createAsyncThunk(
	'/getDefectCategoryTypes',
	async (categoryId) => {
    const response = await axios.get(`/GetDefectCategoryTypes/${categoryId}`);
    return response.data;
  }
);

export const getDefectsByCategoryAndType = createAsyncThunk(
	'/getDefectsByCategoryAndType',
	async (req) => {
    const response = await axios.get(`/GetDefectsByCategoryAndType/${req.CategoryId}/${req.TypeId}`);
    return response.data;
  }
);

export const setNoRevenueDefects = createAsyncThunk(
	'/setNoRevenueDefects',
	async (req) => {
    const response = await axios.post(`/SetNoRevenueDefects`, req);
    return response.data;
  }
);

export const getWarrantyTypes = createAsyncThunk(
	'/getWarrantyTypes',
	async () => {
    const response = await axios.get(`/GetWarrantyTypes`);
    return response.data;
  }
);

export const getNoRevenueDefects = createAsyncThunk(
	'/getNoRevenueDefects',
	async () => {
    const response = await axios.get(`/GetNoRevenueDefects`);
    return response.data;
  }
);

export const deleteNoRevenueDefects = createAsyncThunk(
	'/deleteNoRevenueDefects',
	async (req) => {
    const response = await axios.delete(`/DeleteNoRevenueDefect/${req.DefectId}/${req.WarrantyTypeId}`);
    return response.data;
  }
);

const noRevenueDefectsSlice = createSlice({
  name: 'noRevenueDefects',
  initialState: {
    loading: false,
    error: '',
    DefectCategories: [],
		DefectCategoryTypes: [],
		DefectsByCategoryAndType: [],
		WarrantyTypes: [],
    NoRevenueDefects: []
  },
  reducers: { 
    resetDescriptions(state) {
      state.DefectCategories = [];
			state.DefectCategoryTypes = [];
			state.DefectsByCategoryAndType = [];
			state.WarrantyTypes = []
      state.NoRevenueDefects = []
    }
  },
  extraReducers: {
    [getDefectCategories.pending]: (state) => {
      state.loading = true;
    },
    [getDefectCategories.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getDefectCategories.fulfilled]: (state, action) => {
      state.DefectCategories = action.payload;
      state.loading = false;
    },
		[getDefectCategoryTypes.pending]: (state) => {
      state.loading = true;
    },
    [getDefectCategoryTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getDefectCategoryTypes.fulfilled]: (state, action) => {
      state.DefectCategoryTypes = action.payload;
      state.loading = false;
    },
		[getDefectsByCategoryAndType.pending]: (state) => {
      state.loading = true;
    },
    [getDefectsByCategoryAndType.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getDefectsByCategoryAndType.fulfilled]: (state, action) => {
      state.DefectsByCategoryAndType = action.payload;
      state.loading = false;
    },
		[getWarrantyTypes.pending]: (state) => {
      state.loading = true;
    },
    [getWarrantyTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWarrantyTypes.fulfilled]: (state, action) => {
      state.WarrantyTypes = action.payload;
      state.loading = false;
    },
    [setNoRevenueDefects.pending]: (state) => {
      state.loading = true;
    },
    [setNoRevenueDefects.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setNoRevenueDefects.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [getNoRevenueDefects.pending]: (state) => {
      state.loading = true;
    },
    [getNoRevenueDefects.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getNoRevenueDefects.fulfilled]: (state, action) => {
      state.NoRevenueDefects = action.payload;
      state.loading = false;
    },
    [deleteNoRevenueDefects.pending]: (state) => {
      state.loading = true;
    },
    [deleteNoRevenueDefects.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [deleteNoRevenueDefects.fulfilled]: (state, action) => {
      state.loading = false;
    },
  }
});

export const noRevenueDefectsActions = noRevenueDefectsSlice.actions;
export default noRevenueDefectsSlice;